import EmptyState from './EmptyState';

function Table({ columns, rows, emptyState }) {
  return (
    <div className="min-h-0 flex-1 overflow-x-auto rounded-[22px] border border-[#dfd1c4] bg-white shadow-[0_14px_30px_rgba(69,48,33,0.08)]">
      <table className="min-w-[720px] w-full border-collapse">
        <thead>
          <tr>
            {columns.map((column) => (
              <th
                className="border-b border-[#e3d7cb] bg-[#ece3da] px-3 py-3 text-left text-[0.74rem] uppercase tracking-[0.08em] text-[#7f6e61]"
                key={column.key}
              >
                {column.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.length ? (
            rows.map((row) => (
              <tr className="transition hover:bg-[#f4ece4]" key={row.id}>
                {columns.map((column) => (
                  <td className="border-b border-[#e8ddd2] px-3 py-3 text-left text-[#111111]" key={column.key}>
                    {typeof column.render === 'function' ? column.render(row) : row[column.key]}
                  </td>
                ))}
              </tr>
            ))
          ) : (
            <tr>
              <td className="border-b-0 p-0" colSpan={columns.length}>
                <EmptyState {...emptyState} />
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}

export default Table;
